import { createClearPropMutation, createSetPropMutation } from '@/store/utils';
import * as types from '@/store/pagination/mutationTypes';

export default {
  [types.SET_ITEMS_PER_PAGE]: createSetPropMutation('paginationItemsPerPageByTabs', {
    topLevelDomain: 20,
    infrastructure: 20,
    cloud: 20,
    cloudAccount: 20,
    employees: 20,
    technologies: 20,
    bucket: 20,
    services: 20,
    projects: 20,
    centralizedIssues: 20,
    reports: 20,
    leaks: 20,
  }),
  [types.CLEAR_ITEMS_PER_PAGE]: createClearPropMutation('paginationItemsPerPageByTabs', {
    topLevelDomain: 20,
    infrastructure: 20,
    cloud: 20,
    cloudAccount: 20,
    employees: 20,
    technologies: 20,
    bucket: 20,
    services: 20,
    projects: 20,
    centralizedIssues: 20,
    reports: 20,
    leaks: 20,
  }),
  [types.SET_PROJECTS_PAGINATION_STATE]: createSetPropMutation('projectsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.SET_CLOUD_ACCOUNTS_PAGINATION_STATE]: createSetPropMutation('cloudAccountsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.CLEAR_CLOUD_ACCOUNTS_PAGINATION_STATE]: createClearPropMutation('cloudAccountsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.CLEAR_PROJECTS_PAGINATION_STATE]: createClearPropMutation('projectsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.SET_CENTRALIZED_ISSUES_PAGINATION_STATE]: createSetPropMutation('centralizedIssuesPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.CLEAR_CENTRALIZED_ISSUES_PAGINATION_STATE]: createClearPropMutation('centralizedIssuesPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.SET_INTEGRATIONS_PAGINATION_STATE]: createSetPropMutation('integrationsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.CLEAR_INTEGRATIONS_PAGINATION_STATE]: createClearPropMutation('integrationsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.SET_HIGHLIGHT_REPORTS_PAGINATION_STATE]: createSetPropMutation('highlightReportsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.CLEAR_HIGHLIGHT_REPORTS_PAGINATION_STATE]: createClearPropMutation('highlightReportsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.SET_SERVICES_ASSETS_PAGINATION_STATE]: createSetPropMutation('servicesAssetsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.CLEAR_SERVICES_ASSETS_PAGINATION_STATE]: createClearPropMutation('servicesAssetsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.SET_TOP_LEVEL_DOMAIN_PAGINATION_STATE]: createSetPropMutation('topLevelDomainsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.CLEAR_TOP_LEVEL_DOMAIN_PAGINATION_STATE]: createClearPropMutation('topLevelDomainsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.SET_INFRASTRUCTURE_PAGINATION_STATE]: createSetPropMutation('infrastructurePaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.CLEAR_INFRASTRUCTURE_PAGINATION_STATE]: createClearPropMutation('infrastructurePaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.SET_LEAKS_PAGINATION_STATE]: createSetPropMutation('leaksPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.CLEAR_LEAKS_PAGINATION_STATE]: createClearPropMutation('leaksPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.SET_EMPLOYEES_PAGINATION_STATE]: createSetPropMutation('employeesPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.CLEAR_EMPLOYEES_PAGINATION_STATE]: createClearPropMutation('employeesPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.SET_TECHNOLOGIES_PAGINATION_STATE]: createSetPropMutation('technologiesPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.CLEAR_TECHNOLOGIES_PAGINATION_STATE]: createClearPropMutation('technologiesPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.SET_CLOUD_INSTANCES_PAGINATION_STATE]: createSetPropMutation('cloudInstancesPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.CLEAR_CLOUD_INSTANCES_PAGINATION_STATE]: createClearPropMutation('cloudInstancesPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.SET_CLOUD_BUCKETS_PAGINATION_STATE]: createSetPropMutation('cloudBucketsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.CLEAR_CLOUD_BUCKETS_PAGINATION_STATE]: createClearPropMutation('cloudBucketsPaginationState', {
    page: 1,
    total: 0,
    count: 0,
    pageCount: 1,
  }),
  [types.SET_INFOSTEALERS_PAGINATION_STATE]: createSetPropMutation('infostealersPaginationState', {
    page: 1,
    itemsPerPage: 20,
    total: 0,
    hasNext: false,
    hasPrevious: false,
    totalPages: 1,
  }),
  [types.CLEAR_INFOSTEALERS_PAGINATION_STATE]: createClearPropMutation('infostealersPaginationState', {
    page: 1,
    itemsPerPage: 20,
    total: 0,
    hasNext: false,
    hasPrevious: false,
    totalPages: 1,
  }),
};
